import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
    <path
      fill="#fff"
      d="M5.4 13.843a.835.835 0 1 1-1.669 0 .835.835 0 0 1 1.67 0ZM14.582 13.843a.835.835 0 1 1-1.67 0 .835.835 0 0 1 1.67 0Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeWidth={1.502}
      d="M1.227 1.323h.506a1.67 1.67 0 0 1 1.66 1.489l.677 6.204a1.67 1.67 0 0 0 1.66 1.488h7.22a1.67 1.67 0 0 0 1.618-1.256L15.72 4.73a1.67 1.67 0 0 0-1.617-2.082H4.232m.02 10.881h.627m-.626.626h.626m8.555-.626h.626m-.626.626h.626m-8.66-.313a.835.835 0 1 1-1.669 0 .835.835 0 0 1 1.67 0Zm9.182 0a.835.835 0 1 1-1.67 0 .835.835 0 0 1 1.67 0Z"
    />
  </svg>
)
export default SvgComponent
